import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-revise-completion',
  templateUrl: './revise-completion.component.html',
  styleUrls: ['./revise-completion.component.css']
})
export class ReviseCompletionComponent implements OnInit {

  topicCardList:any = [];
  disableNextTopic:boolean = false;
  constructor(public router:Router, public selfLearnService:SelfLearnService) { }

  ngOnInit(): void {
    this.publishedVideoAndFlashcardCount();
  }

  navigateToChapterPractice(){
    this.router.navigateByUrl("selfLearn-V2/chapter");
  }

  getTopicName(){
    return this.selfLearnService.getTopicName();
  }

  goToNextTopic(){
    this.setTopicAndNavigateToTopicSummary();
  }

  publishedVideoAndFlashcardCount(){
    this.selfLearnService.publishedVideoAndFlashcardCount().subscribe((resp:any) => {
      console.log(resp.data);
      if(resp?.data){
        this.topicCardList = resp?.data;
        this.topicCardList.map((item:any) => {
          if(item.flashcardTaggedQuestionsCount > 0){
            item.publishedFlashcardCount = item.publishedFlashcardCount + 1;
          }
          return {...item};
        });
      }
      this.disableNextTopic = this.checkIfLastTopic();
    })
  }

  setTopicAndNavigateToTopicSummary(){
    const selectedTopic = this.getTopic();
    if(selectedTopic.length > 0) {this.setLocalStorageForTopics(selectedTopic);this.navigateToTopicDetails()}
  }

  checkIfLastTopic(){
    return (this.getTopic().length == 0) ? true : false;
  }

  getTopic(){
    const currentTopicId = this.selfLearnService.getTopicId();
    let nextTopic
    const selectedTopic = this.topicCardList.map((topic:any,row:any) => {
      nextTopic = this.topicCardList[row+1]
        if(topic.topicId == currentTopicId){return nextTopic};
      }).filter((element:any) => {return (element)});
    return selectedTopic;
  }

  setLocalStorageForTopics(selectedTopic:any){
    localStorage.setItem("selfLearnSelectedTopicId", selectedTopic[0].topicId);
    localStorage.setItem("selfLearnSelectedTopicName", selectedTopic[0].topicName);
    localStorage.setItem('subtopicCount', selectedTopic[0].subtopicsCount);
    localStorage.setItem("SelectedFlashcardData", JSON.stringify(selectedTopic[0]));
  }

  navigateToTopicDetails(){
    this.router.navigateByUrl("selfLearn-V2/topic-summary-details");
  }
  goToReviseModule(){
    this.router.navigateByUrl("selfLearn-V2/chapter");
  }

}
